/* tslint:disable */
/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';

import { BaseService } from '../base-service';
import { ApiConfiguration } from '../api-configuration';
import { StrictHttpResponse } from '../strict-http-response';


import { validateUpdateMsAzureUserId } from '../fn/public-controller/validate-update-ms-azure-user-id';
import { ValidateUpdateMsAzureUserId$Params } from '../fn/public-controller/validate-update-ms-azure-user-id';
import { downloadFilesZip } from '../fn/public-controller/download-files-zip';
import { DownloadFilesZip$Params } from '../fn/public-controller/download-files-zip';


@Injectable({ providedIn: 'root' })
export class PublicControllerService extends BaseService {
  constructor(config: ApiConfiguration, http: HttpClient) {
    super(config, http);
  }

  /** Path part for operation `validateUpdateMsAzureUserId()` */
  static readonly ValidateUpdateMsAzureUserIdPath = '/public/validate_update_ms_azure_user_id';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `validateUpdateMsAzureUserId()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  validateUpdateMsAzureUserId$Response(params: ValidateUpdateMsAzureUserId$Params, context?: HttpContext): Observable<StrictHttpResponse<string>> {
    return validateUpdateMsAzureUserId(this.http, this.rootUrl, params, context);
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `validateUpdateMsAzureUserId$Response()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  validateUpdateMsAzureUserId(params: ValidateUpdateMsAzureUserId$Params, context?: HttpContext): Observable<string> {
    return this.validateUpdateMsAzureUserId$Response(params, context).pipe(
      map((r: StrictHttpResponse<string>): string => r.body)
    );
  }

  /** Path part for operation `downloadFilesZip()` */
  static readonly DownloadFilesZipPath = '/public/download_files_zip';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `downloadFilesZip()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  downloadFilesZip$Response(params: DownloadFilesZip$Params, context?: HttpContext): Observable<StrictHttpResponse<Blob>> {
    return downloadFilesZip(this.http, this.rootUrl, params, context);
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `downloadFilesZip$Response()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  downloadFilesZip(params: DownloadFilesZip$Params, context?: HttpContext): Observable<Blob > {
    return this.downloadFilesZip$Response(params, context).pipe(
      map((r: StrictHttpResponse<Blob>): Blob  => r.body)
    );
  }
  
}
